import { useContext as e } from "react";
import { IressModalContext as s } from "../ModalProvider.js";
function u(n) {
  const o = e(s);
  return {
    opened: n && (o == null ? void 0 : o.opened.includes(n)),
    container: o == null ? void 0 : o.container,
    show: (t) => n && (o == null ? void 0 : o.showModal(n, t))
  };
}
export {
  u as useIDSProvidedModal
};
